(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bnl-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bnl-slider')) {
    customElements.define('bnl-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.dots.forEach((d) => d.addEventListener('click', () => { this.go(Number(d.dataset.dot)); this.restart(); }));
        this.track.addEventListener('scroll', () => {
          const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
          if (i !== this.index) { this.index = i; this.mark(); }
        }, { passive: true });
        this.restart();
        this.addEventListener('pointerenter', () => clearInterval(this.timer));
        this.addEventListener('pointerleave', () => this.restart());
      }
      disconnectedCallback() { clearInterval(this.timer); }
      restart() {
        clearInterval(this.timer);
        if (this.dataset.autoplay === 'true' && this.dots.length > 1) {
          this.timer = setInterval(() => this.go((this.index + 1) % this.dots.length), Number(this.dataset.speed || 5) * 1000);
        }
      }
      go(i) { this.index = i; this.track.scrollTo({ left: i * this.track.clientWidth }); this.mark(); }
      mark() { this.dots.forEach((d, n) => { if (n === this.index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); }); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnl-reason-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bnl-scroller')) {
    customElements.define('bnl-scroller', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : track.clientWidth);
        this.querySelector('[data-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.querySelector('[data-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        const sync = () => { const arrows = this.querySelector('.bnl-reasons__arrows'); if (arrows) arrows.hidden = track.scrollWidth <= track.clientWidth + 4; };
        sync(); window.addEventListener('resize', sync);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
